<div class="subscription-page">
  <div class="container">
    <div class="row">
      <div class="col-md-8 offset-md-2">
        <h1>Welcome Back! 👋</h1>
        <p>
          You had an earlier Client Hub subscription that has been canceled.
          Your prior data is preserved and you can access that by resubscribing
          here.
        </p>
        <p class="mb-5">
          Your team and clients who have created login in Client Hub will also
          be able to log back in to their accounts.
          <a
            href="https://www.clienthub.app/pricing"
            target="_blank"
            rel="noopener"
            >Check our latest subscription pricing</a
          >.
        </p>

        <div class="card" style="border-radius: 16px">
          <div class="card-body px-4 py-4">
            <div class="offer mb-3">Special Offer</div>
            <h4>Get a new 14-day free trial for returning subscribers.</h4>
            <p>Expires May 31, 2025</p>

            <form class="mt-4" action="/charge" method="post" id="payment-form">
              <div class="d-flex align-items-end gap-3">
                <div class="flex-grow-1">
                  <div class="form-row">
                    <label for="card-element">Credit or debit card</label>
                    <div class="form-control">
                      <div id="card-element" style="margin-top: 3px">
                        <!-- A Stripe Element will be inserted here. -->
                      </div>
                    </div>
                    <!-- Used to display form errors. -->
                    <div id="card-errors" role="alert"></div>
                  </div>
                </div>
                <div class="">
                  <button
                    type="submit"
                    class="btn btn-primary"
                    [disabled]="loading"
                  >
                    Renew Subscription
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
